import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import "assets/scss/material-kit-react.scss?v=1.9.0";

import TextField from '@material-ui/core/TextField';

import Icon from "@material-ui/core/Icon";

// pages for this product
import Components from "views/Components/Components.js";
import LandingPage from "views/LandingPage/LandingPage.js";
import ProfilePage from "views/ProfilePage/ProfilePage.js";
import LoginPage from "views/LoginPage/LoginPage.jsx";
import PrincipalPage from "views/PrincipalPage/PrincipalPage.jsx";
import CarrinhoCompra from "views/CarrinhoCompra/CarrinhoCompra.jsx";
import SelecionaProd_selecionaSabor from "views/PrincipalPage/SelecionaProd_selecionaSabor.jsx";
import UsuarioInfo_addend from "views/LoginPage/UsuarioInfo_addendereco.jsx";

import FinalizaCompra from "views/FinalizaCompra/FinalizaCompra.jsx";

import PedidoLista from "views/PedidoLista/PedidoLista.jsx";
import PedidoStatus from "views/PedidoLista/PedidoStatus.jsx";

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";

import ProductObj from 'funcs/ProductObj.js';

import load from 'assets/img/loading.gif';
import 'assets/css/index.css';
import Axios from "axios";

import { renovaJWT, temPedidos } from 'funcs/MyFuncs.js';

import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import { BS_ALE } from "funcs/MyFuncs";

import myCookies from 'universal-cookie';

import 'prevent-pull-refresh';

import Confirmacao from "components/Dialogs/Confirmacao.js";

import InfoOutlined from "@material-ui/icons/InfoOutlined";

import AddToHomescreen from 'react-add-to-homescreen';

var hist = createBrowserHistory({
  basename: '/fazseupedido'
});

global.siteurl = "https://sisecomm.com.br/vmxdelivery/";
global.timeOutTimer = 20000;

global.infoObrig       = "";
global.infoObrigTitulo = ""
global.mostraTermos    = true;
global.infoObrigVer    = 0;

global.infoAdic        = "";
global.infoAdicTitulo  = "";

global.tipoCalcPrecoMisto     = 1;
global.tipoCalcPrecoAdicional = 1;

global.urlServer   = "https://sisecomm.com.br/vmxdelivery/";
global.versaoApp   = 23;
global.usr_id      = 12;

global.versaoApp       = "44";

global.restAberto      = "1";
global.restEndereco    = "";

global.proximaAbertura = "";
global.horariosFunc    = [];

global.restPonBal      = "0";
global.restPonDel      = "0";

global.restPerBal      = "0";
global.restPerDel      = "0";

global.temPedidos      = "0";
global.mostrouDicas    = false;

global.tentativaRequestConfig = "";

global.hashRest             = "";
global.cod_grurest          = "199";
global.nome_rest            = "Mr Bolat";
global.cod_restaurante      = "14";
global.exObs                = "Ex: Ponto da carne, bebida sem gelo, com gelo, etc.";
global.msg_retirada         = "Não esqueça de vir de máscara";
global.mostraUnidade        = false;
global.facebookID           = "895662054305928";
global.tel_restaurante      = "(11) 9999-9999";

global.ProductObj = new ProductObj();

global.chaveLocalLogin      = "@vmx-001/" + global.cod_restaurante + "rockstar";

global.corDegrade01         = "#ffc72c";
global.corDegrade02         = "#d2a84c";
global.rgBarraInfo          = "#FFC72C";
global.rgBarraInfoEscuro    = "#EBB318";
global.rgBarraInfoFont      = "rgb(0, 0, 0)";
global.rgBarraSubInfo       = "#DADADA";
global.rgBarraSubInfoEscuro = "#C6C6C6";
global.rgBarraSubInfoFont   = "rgb(0, 0, 0)";
global.rgFundo              = "#FFFFFF";
global.rgFundoFont          = "rgb(0, 0, 0)";
global.rgRetirar            = "#FF0000";

global.mensagemUnidadeShowed = false;
global.txtMensagemUnidade = 'Produtos em quilo podem ter variação em seu peso/preço devido ao tamanho do produto e corte. Variação média de 10% para mais ou para menos.';

// CORES

global.pedidosPendentes   = false;

export function pass_function(message){
  alert('42');
}

class IndexPage extends React.Component { 

  alertaExibido = false;

  URLToArray(url) {
    var request = {};
    var pairs = url.substring(url.indexOf('?') + 1).split('&');
    for (var i = 0; i < pairs.length; i++) {
        if(!pairs[i])
            continue;
        var pair = pairs[i].split('=');
        request[(pair[0])] = (pair[1]);
     }
     return request;
  }

  handleAddToHomescreenClick = () => {
    alert(`
      1. Open Share menu
      2. Tap on "Add to Home Screen" button`);
  };

  vmxale = (title, message) => {
    this.setState({
      mostraVmxAle: true,
      textVmxAle: message,
      titleVmxAle: title,
    });
  }

  ArrayToURL(array) {
    var pairs = [];
    for (var key in array)
      if (array.hasOwnProperty(key))
  
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(array[key]));
    return pairs.join('&');
  }

  constructor(props) {
    super(props);

    var scrollPos = 0;

    navigator.serviceWorker.getRegistrations().then(function(registrations) {

      for(let registration of registrations) {
  
              registration.unregister()
  
      }}).catch(function(err) {
  
          console.log('Service Worker registration failed: ', err);
  
      });

    this.state = { 
        estadoApp: 0,
        appCarregado: false,
        mostraVmxAle: false,
        textVmxAle: '',
        titleVmxAle: '',
        dicaShowed: '0',
        cookieAcceptName: 'myAwesomeCookie',
        delayRender: true,
        carregando: true,
        alertaPedPend: false,
    };

    global.axiosTentativas = 0;

    let meuToken = localStorage.getItem(global.chaveLocalLogin);
    meuToken = meuToken;

    global.myToken = meuToken;

    global.descontoApp = 5;

    this.carregaDados = this.carregaDados.bind(this);

  }

  componentDidMount(){
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const rest = params.get('rest'); // bar

    if (rest){
      global.hashRest = rest;
      localStorage.setItem('@vmx-001/ultimorest', rest);
    }else{
      var parametroLocal = localStorage.getItem('@vmx-001/ultimorest');
      if (parametroLocal) {
        global.hashRest = parametroLocal;
      }
    }

    global.mensagemUnidadeShowed = false;

    this.setState({
      carregando: true
    }, () => {
      setTimeout(() => {
        this.setState({
          carregando : false,
        }, () => {
          document.activeElement.blur();
        })
      }, 500);
    });

    let meuToken = localStorage.getItem(global.chaveLocalLogin);
    meuToken = meuToken;

    global.myToken = meuToken;
    
    window.addEventListener('scroll', this.handleScroll);
    //window.addEventListener("resize", this.handleResize);

    Axios.interceptors.request.use((config) => {
      return new Promise((resolveAxios, rejectAxios) => {
        //window.scrollTo(0, 0);

        let meuToken = localStorage.getItem(global.chaveLocalLogin);
        meuToken = meuToken;

        var dataArr = this.URLToArray(config.data);
        dataArr.parres = global.cod_restaurante;
        dataArr.partoken = meuToken;
        config.data = this.ArrayToURL(dataArr);

        if (config.url == global.siteurl + "pedido_consulta_simplificado.php"){
          resolveAxios(config);
        }else{
          this.setState({ "estadoApp" : 0 }, () => {
            document.body.style.overflowY = "hidden";
            resolveAxios(config);
          });
        }
      });
      
    });

    Axios.interceptors.response.use((response) => {
      // Do something with response data

      if (response.data.verifica_rest){
        global.tel_restaurante = (response.data.verifica_rest.telefone)     ? response.data.verifica_rest.telefone     : global.tel_restaurante;
        global.restAberto      = (response.data.verifica_rest.aberto)       ? response.data.verifica_rest.aberto       : global.restAberto;
        global.temPedidos      = (response.data.verifica_rest.tempedido)    ? response.data.verifica_rest.tempedido    : global.temPedidos;
        global.restEndereco    = (response.data.verifica_rest.endereco)     ? response.data.verifica_rest.endereco     : global.restEndereco;

        global.proximaAbertura = (response.data.verifica_rest.proxmsg)      ? response.data.verifica_rest.proxmsg      : global.proximaAbertura;
        global.horariosFunc    = (response.data.verifica_rest.horariosFunc) ? response.data.verifica_rest.horariosFunc : global.horariosFunc;
 
        global.restPonBal      = (response.data.verifica_rest.rest_ponbal)  ? response.data.verifica_rest.rest_ponbal  : global.restPonBal;
        global.restPonDel      = (response.data.verifica_rest.rest_pondel)  ? response.data.verifica_rest.rest_pondel  : global.restPonDel;

        global.restPerBal      = (response.data.verifica_rest.rest_perret)  ? response.data.verifica_rest.rest_perret  : global.restPerBal;
        global.restPerDel      = (response.data.verifica_rest.rest_perdel)  ? response.data.verifica_rest.rest_perdel  : global.restPerDel;

        global.pedidosPendentes  = (response.data.verifica_rest.pedidopendente != undefined) ? response.data.verifica_rest.pedidopendente : global.pedidosPendentes;

        if (!global.mostrouDicas){
          global.mostrouDicas = true;
          setTimeout( () => {
            const cookies = new myCookies();

            this.setState({
              dicaShowed: cookies.get(global.cod_restaurante + '_dicaShowed') || '0',
              cookieAcceptName: global.cod_restaurante + '_myAwesomeCookie',
              alertaPedPend: (!this.alertaExibido) ? (global.pedidosPendentes) : false,
            }, () => {
              this.mostraDicas();
            });
          }, 600);
        }else if (!this.alertaExibido){
          setTimeout( () => {
            const cookies = new myCookies();

            this.setState({
              alertaPedPend: (global.pedidosPendentes),
            });
          }, 600);
        }
        
      }

      if (response.data.resposta == "99"){
        return new Promise((resolveAxios, rejectAxios) => {
          setTimeout(() => {
            resolveAxios(Axios(response.config));
          }, 3000);
        });
      }else{
        return new Promise((resolveAxios, rejectAxios) => {
          setTimeout(() => {
            this.setState({ "estadoApp" : 1 }, () => {
              setTimeout(async () => {
  
                var dataArr = this.URLToArray(response.config.data);
                dataArr.partoken = global.myToken;
                response.config.data = this.ArrayToURL(dataArr);
                
                if (response.config.url == global.siteurl + "renova_jwt.php"){
                  resolveAxios(response);
                }else if (response.config.url == global.siteurl + "verifica_cep.php"){
                  global.axiosTentativas = 0;
                  document.body.style.overflowY = "scroll";
                  resolveAxios(response);
                }else if (response.data.resposta == "2"){
                  global.tentativaRequestConfig = response.config;
                  if(await renovaJWT()){         
                    var dataArr = this.URLToArray(global.tentativaRequestConfig.data);
                    dataArr.partoken = global.myToken;
                    global.tentativaRequestConfig.data = this.ArrayToURL(dataArr);         
                    resolveAxios(Axios(global.tentativaRequestConfig));
                  }
                }else{
                  global.axiosTentativas = 0;
                  document.body.style.overflowY = "scroll";
                  resolveAxios(response);
                }
                
              }, 0);
  
            });
          }, 300);
        });
      }

    },(error) => {
      global.axiosTentativas = global.axiosTentativas + 1;

      if (Axios.isCancel(error)){

        return new Promise((resolveAxios, rejectAxios) => {
          this.setState({ "estadoApp" : 1 }, () => {
            setTimeout(() => {
              global.axiosTentativas = 0;
              rejectAxios(error);
            },0);
          });
        });

      }else if (global.axiosTentativas < 3) {
        return new Promise((resolveAxios, rejectAxios) => {
          setTimeout(() => {
            const requestConfig = error.config;
            resolveAxios(Axios(requestConfig));
          },3000);
        });
      }else{

        if (error.config.url == global.siteurl + "consulta_pedido.php"){
          global.axiosTentativas = 0;
          return Promise.reject(error);
        }

        return new Promise((resolveAxios, rejectAxios) => {
          this.setState({ "estadoApp" : 1 }, () => {

            setTimeout(() => {
              global.axiosTentativas = 0;
              rejectAxios(error);
            },0);

          });
        });
      }
    });

    this.carregaDados();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    //window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    if (window.scrollY < 100){
      setTimeout( () => {
        window.scrollTo(0, 100); 
      }, 300);  
    }
  }

  handleScroll = () => {
    if (window.scrollY < 100){
      window.scrollTo(0, 100); 
      setTimeout( () => {
        window.scrollTo(0, 100); 
      }, 300);      
    }
  }

  htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  mostraDicas = () => {

    const cookies = new myCookies();

    if (global.temPedidos > 0){

      var randomNb = Math.floor(Math.random() * 10) + 1;

      if (randomNb <= 3){
        if (this.state.dicaShowed != '1'){
          
          var now = new Date();
          var time = now.getTime();
          var maxAge     = 60*60*24*15;
          var expireTime = time + maxAge;

          var expires = (new Date(expireTime));

          cookies.set(global.cod_restaurante + '_dicaShowed', '1', { path: '/', expires: expires, maxAge: maxAge });
          this.setState({
            dicaShowed: cookies.get(global.cod_restaurante + '_dicaShowed') || '0'
          })


          BS_ALE(this, 'Você sabia?', 'Você pode facilitar seu dia adicionando os produtos de um de seus pedidos já realizados ao seu carrinho, na lista de pedidos escolha o pedido que deseja copiar os produtos e clique em ADICIONAR AO CARRINHO.')
        }
      }      
    }
  }

  carregaDados(){

    const cookies = new myCookies();

    var CancelToken = Axios.CancelToken;

    var parametros = 'parhash=' + global.hashRest;

    let source = CancelToken.source();
    setTimeout(() => {
      source.cancel();
      console.log('TIMEOUT');
    }, global.timeOutTimer);

    Axios.post(
      global.siteurl + 'loja_pesquisa.php', 
      parametros,
      {
          cancelToken: source.token,
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
          },
          withCredentials: true,
      }).then((response) => {
        var responseData = response.data;
        global.pedidoAtencao = false;

        if (responseData.resposta == '1') {
          var item = responseData.rests[0];

          global.cod_grurest          = item.mordor;
          global.nome_rest            = item.nome;
          global.cod_restaurante      = item.gondor;
          global.exObs                = item.exObs;
          global.msg_retirada         = item.msgRetirada;
          global.mostraUnidade        = item.mostraUnd;
          global.facebookID           = item.facebookID;
          global.tel_restaurante      = item.telefone;

          global.descontoApp          = item.descapp;

          global.ProductObj = new ProductObj();

          global.chaveLocalLogin      = "@vmx-001/" + global.cod_restaurante + "rockstar";

          if ( item.infoObrig ) {
            var decodedString = this.htmlDecode(item.infoObrig);
            global.infoObrig = '<html><head><meta name="viewport" content="width=device-width, initial-scale=1.0"><style>body { width: 95%; word-wrap: break-word; overflow-wrap: break-word; }</style></head><body>' + decodedString + '</body></html>';// ;
            global.infoObrig = global.infoObrig.replace(/<a[^>]*>/g, '<u>').replace(/<\/a>/g, "</u>");
            global.infoObrig = global.infoObrig.replace(/<A[^>]*>/g, '<u>').replace(/<\/A>/g, "</u>");

            global.infoObrigTitulo = item.infoObrigTit;
            global.infoObrigVer    = item.infoObrigVer;
          }
          
          if ( item.infoAdic ) {
            var decodedString = this.htmlDecode(item.infoAdic);
            global.infoAdic = '<html><head><meta name="viewport" content="width=device-width, initial-scale=1.0"><style>body { width: 95%; word-wrap: break-word; overflow-wrap: break-word; }</style></head><body>' + decodedString + '</body></html>';// ;
            global.infoAdic = global.infoAdic.replace(/<a[^>]*>/g, '<u>').replace(/<\/a>/g, "</u>");
            global.infoAdic = global.infoAdic.replace(/<A[^>]*>/g, '<u>').replace(/<\/A>/g, "</u>");

            global.infoAdicTitulo = item.infoAdicTit;
          }

          const favicon = document.getElementById("my-shortcut");
          favicon.href = item.iconeNome;

          console.log(favicon);

        }else{
          
        }

        global.pedidosPendentes = responseData.pedidosPendentes;

        this.setState({
          refresh: 1,
          appCarregado: true,
          dicaShowed: cookies.get(global.cod_restaurante + '_dicaShowed') || '0',
          cookieAcceptName: global.cod_restaurante + '_myAwesomeCookie',
          alertaPedPend: (responseData.pedidosPendentes),
        });
    })
  }

  renderGambiarra(){
    return (
      <TextField
          variant="outlined"
          margin="normal"
          autoFocus
          required
          fullWidth
          name="cad_email"
          label=""
          type="email"
          id="cad_email"
          autoComplete="email"
          style={{
            height: '1px',
            width: '1px',
            display: (this.state.carregando) ? 'flex' : 'none'
          }}
      />
    )
  }

  renderRotas(){

    hist.basename = 'fazseupedido';

    this.handleScroll();

    return (
      <div style={{marginTop: '100px'}}>
        {this.renderCarregando()}
        {this.renderGambiarra()}
        <Router history={hist} basename={'/fazseupedido'}>
          <Switch>
            <Route path="/landing-page"                  render={(props) => (<LandingPage                   {...props} vmxale={this.vmxale} />)} />
            <Route path="/profile-page"                  render={(props) => (<ProfilePage                   {...props} vmxale={this.vmxale} />)} />
            <Route path="/login-page"                    render={(props) => (<LoginPage                     {...props} vmxale={this.vmxale} />)} />
            <Route path="/carrinho-compra"               render={(props) => (<CarrinhoCompra                {...props} vmxale={this.vmxale} />)} />
            <Route path="/selecionaprod-seleciona-sabor" render={(props) => (<SelecionaProd_selecionaSabor  {...props} vmxale={this.vmxale} />)} />
            <Route path="/usuarioinfo-addend"            render={(props) => (<UsuarioInfo_addend            {...props} vmxale={this.vmxale} />)} />
            <Route path="/finaliza-compra"               render={(props) => (<FinalizaCompra                {...props} vmxale={this.vmxale} />)} />
            <Route path="/pedido-lista"                  render={(props) => (<PedidoLista                   {...props} vmxale={this.vmxale} />)} />
            <Route path="/pedido-status"                 render={(props) => (<PedidoStatus                  {...props} vmxale={this.vmxale} />)} />
            <Route path="/"                              render={(props) => (<PrincipalPage                 {...props} vmxale={this.vmxale} />)} />
          </Switch>
        </Router>
        <CookieConsent
          location="bottom"
          buttonText="  OK  "
          cookieName={this.state.cookieAcceptName}
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          Para melhorar sua experiência nós usamos cookies essenciais nesse aplicativo, ao continuar navegando, você concorda com essas condições.{" "}
        </CookieConsent>

        <AddToHomescreen onAddToHomescreenClick={this.handleAddToHomescreenClick} />

        {this.renderVmxAle()}
        {this.renderConfirmacao(hist)}
      </div>
    )
  }

  handleClosePedPend = () => {
    this.setState({
      alertaPedPend : false,
    });
  }

  renderConfirmacao = (hist) => {

    return (
      <Confirmacao 
          showAlert={this.state.alertaPedPend}
          onClose={() => {
            if (this.state.alertaPedPend){
              this.alertaExibido = true;
            }
            this.handleClosePedPend();
          }}
          callbackYes={() => {
            if (this.state.alertaPedPend){
              this.alertaExibido = true;
            }
            this.setState({
              alertaPedPend : false,
            }, () => {
              hist.push('pedido-lista');
            });
          }} 
          title={'Atenção'}
          msg={'Você possui pedidos que precisam de sua atenção\n\nDeseja verificar agora?'}
          callbackNo={() => {
              if (this.state.alertaPedPend){
                this.alertaExibido = true;
              }
              this.handleClosePedPend();
          }}
      />
    );
  }

  renderVmxAle = () => {
    if (this.state.mostraVmxAle){
      return(
        <Dialog
            open={this.state.mostraVmxAle}
            onClose={() => {
              this.setState({
                mostraVmxAle: false,
                textVmxAle: '',
                titleVmxAle: '',
              });
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{display: 'flex', flexDirection: 'column'}}>
                    <InfoOutlined style={{ margin: 'auto', marginBottom: '10px', fontSize: '40px', color:"#03a1fc", }} />
                    <text style={{ margin: 'auto', marginBottom: '10px', fontSize: '20px', fontWeight: '500' }}>Informações</text>
                    <div style={{whiteSpace: 'pre-wrap', textAlign: 'center'}}>{this.state.textVmxAle}</div>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{display: 'flex'}}>
                <Button color="primary" style={{backgroundColor: '#03a1fc', margin: 'auto', height: '35px !important', marginBottom: '10px'}} onClick={() => {
                        this.setState({
                          mostraVmxAle: false,
                          textVmxAle: '',
                          titleVmxAle: '',
                        });
                    }}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
      );
    }
  }

  renderCarregando(){
    if (this.state.estadoApp == 0){
      return (
        <div className={'myLoadingGIF'} style={{display: 'flex', width: '100%', height: '100%', backgroundColor: '#fff'}}>
          <img style={{margin: 'auto', width: '95%', maxWidth: '400px'}} src={load} alt="loading..." />       
        </div>
      );
    }
  }

  renderCarregandoNoMatterWhat(){
    return (
      <div className={'myLoadingGIF'} style={{display: 'flex', width: '100%', height: '100%', backgroundColor: '#fff'}}>
        {this.renderGambiarra()}
        <img style={{margin: 'auto', width: '95%', maxWidth: '400px'}} src={load} alt="loading..." />       
        {this.renderVmxAle()}
      </div>
    );
  }

  render() {

    if (this.state.appCarregado){
      return (this.renderRotas());
    }else{
      return (this.renderCarregandoNoMatterWhat());
    }
    
    

    if (this.state.estadoApp == 0){
      return (this.renderCarregando());
    }else{
      return (this.renderRotas());
    }
    
  }
}
export default IndexPage;

ReactDOM.render(
  <IndexPage/>,
  document.getElementById("root")
);
